export default __webpack_public_path__ + "static/media/table.1814be1a.png";